import { Box, BoxProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterPublisher } from '@/components/ui/features/ hubs-conferences/EventsFilter/components/FilterPublisher';
import { FilterReleaseYear } from '@/components/ui/features/ hubs-conferences/EventsFilter/components/FilterReleaseYear';
import { FilterSubjects } from '@/components/ui/features/ hubs-conferences/EventsFilter/components/FilterSubjects';
import { FilterItem } from '@/components/ui/features/library/LibraryFilter/components/FilterItem';
import { Filters } from '@/components/ui/features/library/LibraryFilter/components/Filters';
import { LibraryFilter as LibraryFilterEnum } from '@/enums/LibraryFilter';

export const EventsFilter: FC<BoxProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Box {...props}>
      <Box h="full" layerStyle="blackScrollbar">
        <Filters allowToggle reduceMotion>
          <FilterItem title={t('library.filter.subject')} parameter={LibraryFilterEnum.Subject}>
            <FilterSubjects />
          </FilterItem>
          <FilterItem title={t('library.filter.society')} parameter={LibraryFilterEnum.Publisher}>
            <FilterPublisher />
          </FilterItem>
          <FilterItem title={t('library.filter.releaseYear')} parameter={LibraryFilterEnum.Publisher}>
            <FilterReleaseYear />
          </FilterItem>
        </Filters>
      </Box>
    </Box>
  );
};
